import { matchCompanySubdomain } from '../helpers';
import { useStoragedJwt } from './useDecodedJwt';

/**
 * Papel (role) do usuário na empresa do subdomínio atual.
 *
 * O role vive por empresa (`user.companies[].role`), não no topo do JWT — por
 * isso resolvemos a company pelo subdomínio (mesmo critério do Menu). Base para
 * o gating de navegação por papel (RBAC). Retorna `null` sem sessão/empresa.
 */
export function useCurrentRole(): number | null {
  const decoded = useStoragedJwt();
  if (!decoded) return null;

  const subdomain = matchCompanySubdomain();
  const company = decoded.user.companies.find(
    (item) => item.subdomain === subdomain
  );

  return company?.role ?? null;
}

/** Papéis adicionais do usuário na empresa do subdomínio (vazio se o JWT não os trouxer). */
export function useCurrentAdditionalRoles(): number[] {
  const decoded = useStoragedJwt();
  if (!decoded) return [];

  const subdomain = matchCompanySubdomain();
  const company = decoded.user.companies.find(
    (item) => item.subdomain === subdomain
  );

  return company?.additional_roles ?? [];
}
